module.exports = __webpack_public_path__ + "static/media/testd.140fb13.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/testd.mp4
// module id = LqVj
// module chunks = 0